module.exports = function(name) {
	return require(name);
}


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates/templateLoader.js
 ** module id = 8
 ** module chunks = 0
 **/